"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = _interopRequireDefault(require("settings-ui-app/events.yaml"));

var _usageTracker = require("usage-tracker");

var _Raven = _interopRequireDefault(require("Raven"));

var tracker = (0, _usageTracker.createTracker)({
  events: _events.default,
  properties: {
    namespace: 'settingsui'
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  onError: function onError(err) {
    _Raven.default.captureMessage('usage-tracker-js event error', {
      extra: {
        message: err.message
      }
    });
  }
});
var _default = tracker;
exports.default = _default;
module.exports = exports.default;